"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8883],{

/***/ 112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1025);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65400);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var classname__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80411);
/* harmony import */ var classname__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classname__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var _excluded = ["children", "variant", "onClick", "className", "widthType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var FunctionalButton = function FunctionalButton(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      onClick = _ref.onClick,
      className = _ref.className,
      widthType = _ref.widthType,
      props = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_5__["default"], _objectSpread(_objectSpread({
    onClick: onClick,
    className: classname__WEBPACK_IMPORTED_MODULE_2___default()('font-sfui px-4 py-3 h-12 rounded-lg font-semibold', {
      'border-none bg-g400 text-white': variant === 'contained',
      'border border-n75 text-n800': variant === 'outlined'
    }, widthType === 'max-content' ? 'w-max' : 'w-full', className)
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (FunctionalButton);
FunctionalButton.defaultProps = {
  variant: 'contained',
  widthType: 'max-content',
  className: '',
  onClick: undefined
};

/***/ }),

/***/ 80029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ GoogleSignInButton; }
/* harmony export */ });
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1025);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65400);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54277);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_space__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74048);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47811);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd_lib_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var GoogleSignInButton = function GoogleSignInButton(_ref) {
  var text = _ref.text,
      handleSignIn = _ref.handleSignIn;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_4__["default"], {
    className: "bg-gray-100 text-gray-700 border-none text-sm",
    block: true,
    size: "large",
    onClick: handleSignIn,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd_lib_space__WEBPACK_IMPORTED_MODULE_5__["default"], {
      direction: "horizontal",
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        preview: false,
        style: {
          width: 32
        },
        className: "inline-block",
        src: "/thirdParties/google_g.png"
      }), text]
    })
  });
};

/***/ }),

/***/ 62159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6171);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var ApplicationLayout = function ApplicationLayout(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var handleBack = function handleBack() {
    router.back();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "bg-g500 min-h-screen",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("header", {
      className: "bg-white sticky top-0 z-50 flex items-center justify-center py-4",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        onClick: handleBack,
        className: "bg-white text-g400 hover:text-g500 transition-colors absolute left-4",
        "aria-label": "Go back",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          className: "h-6 w-6"
        }), " Back"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "text-[32px] text-g400 font-extrabold font-sfui",
        children: "Traqqie"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "px-4 md:px-8 lg:px-24",
      children: children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ApplicationLayout);

/***/ }),

/***/ 87290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72220);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useWbsoApplicationById() {
  var _query$data$data, _query$data;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    applicationId: undefined,
    options: {}
  };
  var options = (props === null || props === void 0 ? void 0 : props.options) || {};
  var queryKey = ['get-wbso-application-by-id', props];
  var query = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(queryKey, function () {
    return services__WEBPACK_IMPORTED_MODULE_2__/* .ApiCall.wbso.getApplicationById */ .o.wbso.getApplicationById(props === null || props === void 0 ? void 0 : props.applicationId);
  }, _objectSpread(_objectSpread({}, options), {}, {
    enabled: !!props.applicationId,
    staleTime: 1000 * 60 * 5
  }));
  return _objectSpread(_objectSpread({}, query), {}, {
    data: (_query$data$data = query === null || query === void 0 || (_query$data = query.data) === null || _query$data === void 0 ? void 0 : _query$data.data) !== null && _query$data$data !== void 0 ? _query$data$data : []
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useWbsoApplicationById);

/***/ }),

/***/ 72746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72220);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useWbsoApplicationResponseById() {
  var _query$data$data, _query$data;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    applicationId: undefined,
    options: {}
  };
  var options = (props === null || props === void 0 ? void 0 : props.options) || {};
  var queryKey = ['get-wbso-application-response-by-id', props];
  var query = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(queryKey, function () {
    return services__WEBPACK_IMPORTED_MODULE_2__/* .ApiCall.wbso.getApplicationResponse */ .o.wbso.getApplicationResponse(props === null || props === void 0 ? void 0 : props.applicationId);
  }, _objectSpread(_objectSpread({}, options), {}, {
    enabled: !!props.applicationId // staleTime: 1000 * 60 * 5,

  }));
  return _objectSpread(_objectSpread({}, query), {}, {
    data: (_query$data$data = query === null || query === void 0 || (_query$data = query.data) === null || _query$data === void 0 ? void 0 : _query$data.data) !== null && _query$data$data !== void 0 ? _query$data$data : []
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useWbsoApplicationResponseById);

/***/ }),

/***/ 47089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72220);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useWbsoQuestions(props) {
  var _query$data$data, _query$data;

  var options = (props === null || props === void 0 ? void 0 : props.options) || {};
  var queryKey = ['get-wbso-question', props];
  var query = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(queryKey, function () {
    return services__WEBPACK_IMPORTED_MODULE_2__/* .ApiCall.wbso.getQuestions */ .o.wbso.getQuestions(props === null || props === void 0 ? void 0 : props.uuid);
  }, _objectSpread(_objectSpread({}, options), {}, {
    staleTime: 1000 * 60 * 5
  }));
  return _objectSpread(_objectSpread({}, query), {}, {
    data: (_query$data$data = query === null || query === void 0 || (_query$data = query.data) === null || _query$data === void 0 ? void 0 : _query$data.data) !== null && _query$data$data !== void 0 ? _query$data$data : []
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useWbsoQuestions);

/***/ }),

/***/ 72220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _ApiCall__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ApiCall__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78611);
/* harmony import */ var _Fetcher__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8210);



/***/ }),

/***/ 17301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ApplicationForm; }
});

// EXTERNAL MODULE: ./node_modules/antd/lib/avatar/style/index.js
var style = __webpack_require__(82815);
// EXTERNAL MODULE: ./node_modules/antd/lib/avatar/index.js
var avatar = __webpack_require__(84960);
// EXTERNAL MODULE: ./node_modules/antd/lib/progress/style/index.js
var progress_style = __webpack_require__(92871);
// EXTERNAL MODULE: ./node_modules/antd/lib/progress/index.js
var progress = __webpack_require__(74806);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/style/index.js
var message_style = __webpack_require__(75314);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/index.js
var message = __webpack_require__(11187);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(60536);
var styled_jsx_style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/components/index.js + 17 modules
var components = __webpack_require__(87478);
// EXTERNAL MODULE: ./src/components/GoogleSignInButton/GoogleSignInButton.js
var GoogleSignInButton = __webpack_require__(80029);
// EXTERNAL MODULE: ./src/data/wbsoApp/useWbsoApplicationById.js
var useWbsoApplicationById = __webpack_require__(87290);
// EXTERNAL MODULE: ./src/data/wbsoApp/useWbsoApplicationResponseById.js
var useWbsoApplicationResponseById = __webpack_require__(72746);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(72220);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(80818);
// EXTERNAL MODULE: ./src/utils/pages.js
var pages = __webpack_require__(34052);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/schema/formValidationSchema.js

var createFormValidationSchema = function createFormValidationSchema(prompts, formValues) {
  var shape = prompts.reduce(function (acc, question) {
    var validator = index_esm/* string */.Z_();
    if (question.minLength) validator = validator.min(question.minLength);
    if (question.maxLength) validator = validator.max(question.maxLength);

    if (question.type === 'Enum') {
      var _options = question.options; // Check if options is a string and parse it if necessary

      if (typeof _options === 'string') {
        try {
          _options = JSON.parse(_options);
        } catch (error) {
          console.error('Error parsing options:', error);
        }
      }

      if (Array.isArray(_options)) {
        validator = index_esm/* mixed */.nK().oneOf(_options);
      } else {
        console.error('Expected options to be an array:', _options);
      }
    }

    if (question.type === 'Number') validator = index_esm/* number */.Rx().required();
    if (question.type === 'Date') validator = index_esm/* date */.hT().required();

    if (question.key === 'phase_description') {
      validator = index_esm/* array */.IX().of(index_esm/* object */.Ry().shape({
        milestone: index_esm/* string */.Z_().required('Milestone is required'),
        timeline: index_esm/* string */.Z_().required('Timeline is required')
      }));
    }

    if (question.condition) {
      if (!question.condition(formValues)) {
        validator = validator.notRequired();
      } else {
        validator = validator.required('Required');
      }
    } else {
      validator = validator.required('Required');
    }

    acc[question.key] = validator;
    return acc;
  }, {});
  return index_esm/* object */.Ry().shape(shape);
};
// EXTERNAL MODULE: ./src/views/WBSOApplicationForm/components/Button.js
var Button = __webpack_require__(88264);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/style/index.js
var card_style = __webpack_require__(89626);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/index.js
var card = __webpack_require__(70302);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js + 1 modules
var CheckCircleFilled = __webpack_require__(89739);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(4340);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/components/Intro.js







var CARD_ITEMS_1 = [{
  key: 'card_items.item1',
  checked: true
}, {
  key: 'card_items.item2',
  checked: true
}, {
  key: 'card_items.item3',
  checked: true
}, {
  key: 'card_items.item4',
  checked: true
}, {
  key: 'card_items.item5',
  checked: true
}, {
  key: 'card_items.item6',
  checked: true
}];

var Intro = function Intro(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {
    return '';
  } : _ref$onBack,
      _ref$onContinue = _ref.onContinue,
      onContinue = _ref$onContinue === void 0 ? function () {
    return '';
  } : _ref$onContinue;

  var _useTranslation = (0,esm/* useTranslation */.$G)('application-intro'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col gap-y-4 items-center justify-center py-10 md:gap-y-10 md:py-24",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "text-white text-3xl font-semibold md:text-4xl text-center max-w-3xl leading-tight mb-4",
      children: t('title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
      className: "text-white text-center text-lg md:text-xl",
      children: [t('subtitle'), " "]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
      loading: loading,
      color: "secondary",
      onClick: onContinue,
      className: "animate-pulse-animation",
      children: [t('button_continue_up'), " "]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-col gap-6 lg:flex-row",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IntroCard, {
        title: t('card_title') // Translated title for the card
        ,
        items: CARD_ITEMS_1
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex gap-x-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        variant: "outlined",
        color: "secondary",
        onClick: onBack,
        children: [t('button_back'), " "]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
        loading: loading,
        color: "secondary",
        onClick: onContinue,
        children: [t('button_continue'), " "]
      })]
    })]
  });
};

var IntroCard = function IntroCard(_ref2) {
  var title = _ref2.title,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items;

  var _useTranslation2 = (0,esm/* useTranslation */.$G)('application-intro'),
      t = _useTranslation2.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
    className: "rounded-3xl font-inter max-w-[525px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "text-2xl text-g400 font-semibold md:text-4xl",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "mt-6 flex flex-col gap-y-6",
      children: items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex items-center gap-x-2",
          children: [item.checked ? /*#__PURE__*/(0,jsx_runtime.jsx)(CheckCircleFilled/* default */.Z, {
            className: "text-g500 text-2xl"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CloseCircleFilled/* default */.Z, {
            className: "text-[#FF6666] text-2xl"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-g400",
            children: t(item.key)
          })]
        }, item.key);
      })
    })]
  });
};

/* harmony default export */ var components_Intro = (Intro);
// EXTERNAL MODULE: ./node_modules/antd/lib/alert/style/index.js
var alert_style = __webpack_require__(92015);
// EXTERNAL MODULE: ./node_modules/antd/lib/alert/index.js
var lib_alert = __webpack_require__(4863);
// EXTERNAL MODULE: ./node_modules/antd/lib/upload/style/index.js
var upload_style = __webpack_require__(1131);
// EXTERNAL MODULE: ./node_modules/antd/lib/upload/index.js
var upload = __webpack_require__(28465);
// EXTERNAL MODULE: ./node_modules/antd/lib/date-picker/style/index.js
var date_picker_style = __webpack_require__(62713);
// EXTERNAL MODULE: ./node_modules/antd/lib/date-picker/index.js
var date_picker = __webpack_require__(14321);
// EXTERNAL MODULE: ./node_modules/antd/lib/radio/style/index.js
var radio_style = __webpack_require__(54067);
// EXTERNAL MODULE: ./node_modules/antd/lib/radio/index.js
var lib_radio = __webpack_require__(64713);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/style/index.js
var input_style = __webpack_require__(89858);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/index.js
var input = __webpack_require__(51024);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(25035);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/TextArea.js
var TextArea = __webpack_require__(14104);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/components/MilestoneInput.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var MilestoneInput = function MilestoneInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;

  var _useState = (0,react.useState)(value || [{
    milestone: '',
    timeline: ''
  }]),
      milestones = _useState[0],
      setMilestones = _useState[1];

  var _useState2 = (0,react.useState)([]),
      errors = _useState2[0],
      setErrors = _useState2[1];

  (0,react.useEffect)(function () {
    setMilestones(value || [{
      milestone: '',
      timeline: ''
    }]);
  }, [value]);

  var handleAddRow = function handleAddRow() {
    var updatedMilestones = [].concat((0,toConsumableArray/* default */.Z)(milestones), [{
      milestone: '',
      timeline: ''
    }]);
    setMilestones(updatedMilestones);
    onChange(updatedMilestones, validate(updatedMilestones));
  };

  var handleRemoveRow = function handleRemoveRow(index) {
    var updatedMilestones = milestones.filter(function (_, i) {
      return i !== index;
    });
    setMilestones(updatedMilestones);
    onChange(updatedMilestones, validate(updatedMilestones));
  };

  var handleChange = function handleChange(index, field, val) {
    var updatedMilestones = milestones.map(function (item, i) {
      return i === index ? _objectSpread(_objectSpread({}, item), {}, (0,defineProperty["default"])({}, field, val)) : item;
    });
    setMilestones(updatedMilestones);
    onChange(updatedMilestones, validate(updatedMilestones)); // Clear errors for the updated field

    var updatedErrors = errors.map(function (error, i) {
      return i === index ? _objectSpread(_objectSpread({}, error), {}, (0,defineProperty["default"])({}, field, '')) : error;
    });
    setErrors(updatedErrors);
  };

  var validate = function validate() {
    var milestonesToValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : milestones;
    var newErrors = milestonesToValidate.map(function (item) {
      return {
        milestone: item.milestone ? '' : 'Milestone is required',
        timeline: item.timeline ? '' : 'Timeline is required'
      };
    });
    setErrors(newErrors);
    return newErrors.every(function (error) {
      return !error.milestone && !error.timeline;
    });
  };

  (0,react.useEffect)(function () {
    onChange(milestones, validate(milestones));
  }, [milestones]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [milestones.map(function (item, index) {
      var _errors$index, _errors$index2;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: 'flex',
          marginBottom: '10px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            flex: 1,
            marginRight: '10px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
            type: "text",
            placeholder: "Milestone",
            value: item.milestone,
            onChange: function onChange(e) {
              return handleChange(index, 'milestone', e.target.value);
            },
            style: {
              width: '100%'
            }
          }), ((_errors$index = errors[index]) === null || _errors$index === void 0 ? void 0 : _errors$index.milestone) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              color: 'red'
            },
            children: errors[index].milestone
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            flex: 1
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
            type: "text",
            placeholder: "Timeline",
            value: item.timeline,
            onChange: function onChange(e) {
              return handleChange(index, 'timeline', e.target.value);
            },
            style: {
              width: '100%'
            }
          }), ((_errors$index2 = errors[index]) === null || _errors$index2 === void 0 ? void 0 : _errors$index2.timeline) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              color: 'red'
            },
            children: errors[index].timeline
          })]
        }), index > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          danger: true,
          htmlType: "button",
          onClick: function onClick() {
            return handleRemoveRow(index);
          },
          style: {
            marginLeft: '10px'
          },
          children: "Remove"
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      htmlType: "button",
      onClick: handleAddRow,
      className: "outline-none bg-transparent border border-solid border-g400 text-sm px-2 py-1 rounded-md hover:bg-g500 hover:text-white hover:border-g500",
      children: "Add More"
    })]
  });
};

/* harmony default export */ var components_MilestoneInput = (MilestoneInput);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/components/QuestionView.js




















var QuestionView = function QuestionView(_ref) {
  var _formik$values$key$le, _formik$values$key, _formik$values$key$le2, _formik$values$key2;

  var currentQuestion = _ref.currentQuestion,
      formik = _ref.formik;

  if (!currentQuestion) {
    return null;
  }

  var key = currentQuestion.key,
      title = currentQuestion.title,
      description = currentQuestion.description,
      type = currentQuestion.type,
      minLength = currentQuestion.minLength,
      maxLength = currentQuestion.maxLength,
      optRaw = currentQuestion.options,
      explanation = currentQuestion.explanation;
  var options = typeof optRaw === 'string' ? JSON.parse(optRaw) : optRaw;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "wbso-question flex w-full flex-col gap-y-4",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "text-2xl font-semibold md:text-4xl",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: description
    }), type === 'String' && !options && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
        type: "text",
        name: key,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values[key],
        style: {
          width: '100%'
        },
        maxLength: maxLength,
        minLength: minLength,
        className: "pr-20"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "absolute right-3 top-4 text-sm font-semibold",
        children: [(_formik$values$key$le = (_formik$values$key = formik.values[key]) === null || _formik$values$key === void 0 ? void 0 : _formik$values$key.length) !== null && _formik$values$key$le !== void 0 ? _formik$values$key$le : 0, "/", maxLength]
      })]
    }), type === 'LongText' && key !== 'phase_description' && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextArea["default"], {
        name: key,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values[key],
        rows: "5",
        style: {
          width: '100%'
        },
        maxLength: maxLength,
        minLength: minLength
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-1",
        children: [(_formik$values$key$le2 = (_formik$values$key2 = formik.values[key]) === null || _formik$values$key2 === void 0 ? void 0 : _formik$values$key2.length) !== null && _formik$values$key$le2 !== void 0 ? _formik$values$key$le2 : 0, "/", maxLength]
      })]
    }), type === 'Enum' && /*#__PURE__*/(0,jsx_runtime.jsx)(lib_radio["default"].Group, {
      name: key,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur,
      value: formik.values[key],
      children: options.map(function (option) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(lib_radio["default"], {
          className: "block accent-g400 text-base",
          value: option,
          children: option
        }, option);
      })
    }), type === 'Date' && /*#__PURE__*/(0,jsx_runtime.jsx)(date_picker/* default */.Z, {
      picker: "month",
      format: 'MM-YYYY',
      name: key,
      onChange: function onChange(value) {
        var firstDayOfMonth = value.clone().startOf('month');
        formik.setFieldValue(key, firstDayOfMonth);
      },
      onBlur: formik.handleBlur,
      value: formik.values[key] ? moment_default()(formik.values[key]) : undefined,
      disabledDate: function disabledDate(currentDate) {
        var today = moment_default()().startOf('month');
        return currentDate.isSameOrBefore(today, 'month');
      },
      style: {
        width: '100%'
      }
    }), type === 'Number' && /*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
      type: "number",
      name: key,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur,
      value: formik.values[key],
      style: {
        width: '100%'
      }
    }), type === 'FileUpload' && /*#__PURE__*/(0,jsx_runtime.jsx)(upload/* default */.Z, {
      name: key,
      beforeUpload: function beforeUpload(file) {
        formik.setFieldValue(key, file);
        return false;
      },
      accept: "application/pdf",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "border border-dashed border-g400 h-12 w-full rounded-lg flex items-center justify-center cursor-pointer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "hidden lg:block",
          children: "Click here to browse"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "lg:hidden",
          children: "Tap here to browse"
        })]
      })
    }), type === 'Message' && /*#__PURE__*/(0,jsx_runtime.jsx)(lib_alert["default"], {
      message: description,
      type: "info",
      showIcon: true
    }), key === 'phase_description' && /*#__PURE__*/(0,jsx_runtime.jsx)(components_MilestoneInput, {
      value: formik.values[key],
      onChange: function onChange(val) {
        return formik.setFieldValue(key, val);
      }
    }), formik.errors[key] && formik.touched[key] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-red-500",
      children: formik.errors[key]
    }), explanation && /*#__PURE__*/(0,jsx_runtime.jsx)(Explanation, {
      explanation: explanation
    })]
  }, key);
};

var Explanation = function Explanation(_ref2) {
  var explanation = _ref2.explanation;

  var _useState = (0,react.useState)(false),
      isShown = _useState[0],
      setIsShown = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex items-start gap-x-4",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
      className: "text-2xl mt-1 text-g400"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-start",
      children: [isShown && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: explanation
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: classnames_default()('bg-transparent outline-none underline font-semibold', isShown ? 'mt-4' : 'mt-1'),
        onClick: function onClick() {
          return setIsShown(!isShown);
        },
        children: isShown ? 'Hide tips' : 'View tips'
      })]
    })]
  });
};

/* harmony default export */ var components_QuestionView = (QuestionView);
// EXTERNAL MODULE: ./node_modules/antd/lib/spin/style/index.js
var spin_style = __webpack_require__(9405);
// EXTERNAL MODULE: ./node_modules/antd/lib/spin/index.js
var spin = __webpack_require__(89552);
// EXTERNAL MODULE: ./node_modules/antd/lib/select/style/index.js
var select_style = __webpack_require__(35797);
// EXTERNAL MODULE: ./node_modules/antd/lib/select/index.js
var lib_select = __webpack_require__(64749);
// EXTERNAL MODULE: ./src/components/ButtonV2/FunctionalButton.js
var FunctionalButton = __webpack_require__(112);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/components/SearchKVKForm.js












function SearchKVKForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchKVKForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchKVKForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchKVKForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Option = lib_select["default"].Option;

var SearchKVKForm = function SearchKVKForm(_ref) {
  var initialValue = _ref.initialValue,
      onHandle = _ref.onHandle;

  var _useState = (0,react.useState)(initialValue),
      searchValue = _useState[0],
      setSearchValue = _useState[1];

  var _useState2 = (0,react.useState)(false),
      fetching = _useState2[0],
      setFetching = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      searchResults = _useState3[0],
      setSearchResults = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      selectedCompany = _useState4[0],
      setSelectedCompany = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      companyDomain = _useState5[0],
      setCompanyDomain = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      domainValidationErrors = _useState6[0],
      setDomainValidationErrors = _useState6[1];

  var fetchCompanyData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var _response;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFetching(true);
              setSearchValue(value);

              if (!(value.length > 2)) {
                _context.next = 15;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return services/* ApiCall.searchKvk */.o.searchKvk(value);

            case 6:
              _response = _context.sent;
              setSearchResults(_response.data.map(function (d) {
                return SearchKVKForm_objectSpread(SearchKVKForm_objectSpread({}, d), {}, {
                  displayName: "".concat(d.name, " - KVK: ").concat(d.kvk_number)
                });
              }));
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.error('Error fetching search results:', _context.t0);

            case 13:
              _context.next = 16;
              break;

            case 15:
              setSearchResults([]);

            case 16:
              setFetching(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function fetchCompanyData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSelect = function handleSelect(value) {
    var selected = searchResults.find(function (company) {
      return company.name === value;
    });
    setSelectedCompany(selected); // Store the selected company
  };

  var handleDomainChange = function handleDomainChange(e) {
    setDomainValidationErrors('');
    setCompanyDomain(e.target.value);
  };

  var validateDomain = function validateDomain(domain) {
    // Remove http/https if present
    var strippedDomain = domain.replace(/^(https?:\/\/)?/, ''); // Simple regex to check if domain is in format: name.tld

    var domainPattern = /^[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
    return domainPattern.test(strippedDomain);
  };

  var handleSubmit = function handleSubmit(onHandle) {
    if (!selectedCompany) {
      message["default"].error('Please select a company.');

      return;
    }

    if (!companyDomain || !validateDomain(companyDomain)) {
      setDomainValidationErrors('Please enter a valid domain (e.g., traqqie.com).');
      return;
    } // Strip "http://" if the user accidentally adds it, and pass only the domain


    var cleanDomain = companyDomain.replace(/^(https?:\/\/)?/, ''); // Pass the selected company and clean domain to the onHandle method

    var companyData = SearchKVKForm_objectSpread(SearchKVKForm_objectSpread({}, selectedCompany), {}, {
      domain: cleanDomain
    });

    onHandle(companyData);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib_select["default"], {
      showSearch: true,
      value: (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.name) || searchValue,
      placeholder: "Search for a company",
      className: "search-kvk",
      defaultActiveFirstOption: false,
      showArrow: false,
      filterOption: false,
      onSearch: fetchCompanyData,
      onSelect: handleSelect,
      notFoundContent: fetching ? /*#__PURE__*/(0,jsx_runtime.jsx)(spin["default"], {
        size: "small",
        className: "fill-g400"
      }) : null,
      children: searchResults.map(function (company) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
          value: company.name,
          children: company.displayName
        }, "".concat(company.kvk_number, "-").concat(company.name, "-").concat((0,v4/* default */.Z)()));
      })
    }), selectedCompany && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wbso-question flex w-full flex-col gap-y-4",
      style: {
        marginTop: '16px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To ensure that your company data is correctly linked, please enter your company's domain. This helps us verify your identity and keep your data secure. The domain should match the one used for your email ( e.g., ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "traqqie.com"
        }), ")."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
        style: {
          marginTop: '12px'
        },
        placeholder: "Enter company domain, e.g., google.com",
        value: companyDomain,
        vali: true,
        onChange: handleDomainChange
      }), domainValidationErrors && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          color: 'red',
          marginTop: '8px'
        },
        children: domainValidationErrors
      })]
    }, "ll"), companyDomain && companyDomain && /*#__PURE__*/(0,jsx_runtime.jsx)(FunctionalButton/* default */.Z, {
      type: "primary",
      onClick: function onClick() {
        return handleSubmit(onHandle);
      },
      children: "Next"
    })]
  });
};

/* harmony default export */ var components_SearchKVKForm = (SearchKVKForm);
// EXTERNAL MODULE: ./src/views/WBSOApplicationForm/components/numberWithCommas.js
var numberWithCommas = __webpack_require__(33481);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/components/ApplicationForm.js












function ApplicationForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ApplicationForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ApplicationForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ApplicationForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var ApplicationForm = function ApplicationForm(_ref) {
  var _authUser$company, _router$query$id, _router$query$id2;

  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$withIntro = _ref.withIntro,
      withIntro = _ref$withIntro === void 0 ? false : _ref$withIntro,
      id = _ref.id,
      currentPage = _ref.currentPage,
      initialFormValues = _ref.initialValues,
      _ref$questions = _ref.questions,
      questions = _ref$questions === void 0 ? [] : _ref$questions,
      _ref$feedbacks = _ref.feedbacks,
      feedbacks = _ref$feedbacks === void 0 ? [] : _ref$feedbacks,
      props = _ref.props;
  var LOGIN_REQUIRED_AFTER_QUESTION_INDEX = 3;
  var router = (0,next_router.useRouter)();

  var _message$useMessage = message["default"].useMessage(),
      _message$useMessage2 = (0,slicedToArray/* default */.Z)(_message$useMessage, 2),
      messageApi = _message$useMessage2[0],
      contextHolder = _message$useMessage2[1];

  var _useAuth = (0,components/* useAuth */.aC)(),
      signInWithGoogleAccount = _useAuth.signInWithGoogleAccount,
      authUser = _useAuth.authUser;

  var _useState = (0,react.useState)(false),
      loginNow = _useState[0],
      setLoginNow = _useState[1];

  var isAuthenticated = !!authUser;

  var _useState2 = (0,react.useState)(withIntro),
      showIntro = _useState2[0],
      setShowIntro = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      startingApp = _useState3[0],
      setStartingApp = _useState3[1];

  var _useState4 = (0,react.useState)((authUser === null || authUser === void 0 ? void 0 : authUser.company) !== null),
      hasCompany = _useState4[0],
      setHasCompany = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      currentQuestionIndex = _useState5[0],
      setCurrentQuestionIndex = _useState5[1];

  var _useState6 = (0,react.useState)((_authUser$company = authUser === null || authUser === void 0 ? void 0 : authUser.company) !== null && _authUser$company !== void 0 ? _authUser$company : null),
      companyData = _useState6[0],
      setCompanyData = _useState6[1];

  var _useState7 = (0,react.useState)(true),
      isNextDisabled = _useState7[0],
      setIsNextDisabled = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isSubmiting = _useState9[0],
      setIsSubmiting = _useState9[1];

  var _useState10 = (0,react.useState)(),
      applicationId = _useState10[0],
      setApplicationId = _useState10[1];

  var _useState11 = (0,react.useState)(null),
      claimValue = _useState11[0],
      setClaimValue = _useState11[1];

  var _useWbsoApplicationRe = (0,useWbsoApplicationResponseById/* default */.Z)({
    applicationId: (_router$query$id = router.query.id) !== null && _router$query$id !== void 0 ? _router$query$id : applicationId
  }),
      responses = _useWbsoApplicationRe.data,
      refetchResponse = _useWbsoApplicationRe.refetch;

  (0,react.useEffect)(function () {}, [authUser]);

  var _useWbsoApplicationBy = (0,useWbsoApplicationById/* default */.Z)({
    applicationId: (_router$query$id2 = router.query.id) !== null && _router$query$id2 !== void 0 ? _router$query$id2 : applicationId
  }),
      application = _useWbsoApplicationBy.data,
      refetchApplication = _useWbsoApplicationBy.refetch;

  (0,react.useEffect)(function () {
    if (application) {
      setClaimValue(application.value);
    }
  }, [application]);
  var prompts = questions === null || questions === void 0 ? void 0 : questions.sort(function (a, b) {
    return a.order - b.order;
  }).map(function (v) {
    return ApplicationForm_objectSpread(ApplicationForm_objectSpread({}, v), {}, {
      type: v.question_type,
      minLength: v.min_length,
      maxLength: v.max_length,
      options: v.options ? v.options : null,
      condition: v.condition ? new Function('formData', "return ".concat(v.condition, ";")) : undefined
    });
  });
  var initialValues = prompts.reduce(function (acc, question) {
    var value = question.key === 'phase_description' ? [{
      milestone: '',
      timeline: ''
    }] : '';

    if (initialFormValues) {
      var _questionValue = initialFormValues === null || initialFormValues === void 0 ? void 0 : initialFormValues.find(function (v) {
        return v.question === question.uuid;
      });

      if (_questionValue) {
        if (question.key === 'phase_description') {
          value = JSON.parse(_questionValue.response);
        } else {
          value = _questionValue.response;
        }
      }
    }

    acc[question.key] = value;
    return acc;
  }, {});
  var validationSchema = createFormValidationSchema(prompts, initialValues);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  if (feedbacks) {// Do something if it is feedback page
                  } else if (initialFormValues) {// Do something if it is edit page
                  } else {// Do something if it is create application page
                  }

                  router.push(pages/* PAGE.wbsoAppDashboard */.qX.wbsoAppDashboard);
                  messageApi.open({
                    type: 'success',
                    content: 'Thank you for your application'
                  });
                } catch (error) {
                  messageApi.open({
                    type: 'error',
                    content: 'Failed to save application'
                  });
                } finally {}

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });
  var visibleQuestions = (0,react.useMemo)(function () {
    var updatedVisibleQuestions = prompts.filter(function (question) {
      if (question.condition && currentPage !== 'feedback') {
        return question.condition(formik.values);
      }

      return true;
    });
    return updatedVisibleQuestions;
  }, [formik.values, prompts]);

  if (currentPage === 'feedback' && visibleQuestions.length === 0) {
    router.push(pages/* PAGE.wbsoAppDashboard */.qX.wbsoAppDashboard);
  }

  var currentQuestion = visibleQuestions[currentQuestionIndex];
  var currentResponse = responses === null || responses === void 0 ? void 0 : responses.find(function (v) {
    return v.question === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.uuid);
  });
  var currentFeedback = currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.feedback;
  (0,react.useEffect)(function () {
    var updatedValidationSchema = createFormValidationSchema(prompts, formik.values);
    formik.setErrors({});
    formik.validateForm(updatedValidationSchema);
  }, [formik.values]);
  (0,react.useEffect)(function () {
    if (currentQuestion) {
      formik.validateForm().then(function (errors) {
        var hasErrors = errors[currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.key];
        setIsNextDisabled(!!hasErrors);
      });
    }

    if (currentQuestionIndex >= LOGIN_REQUIRED_AFTER_QUESTION_INDEX && !isAuthenticated) {
      setLoginNow(true);
    }
  }, [currentQuestionIndex, formik.values]);
  (0,react.useEffect)(function () {
    if (isAuthenticated) {
      formik.setFieldValue('authentication', true);
    }
  }, [isAuthenticated]);

  var saveResponse = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee2(questionId, response) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return services/* ApiCall.wbso.saveApplicationResponse */.o.wbso.saveApplicationResponse(applicationId !== null && applicationId !== void 0 ? applicationId : id, [{
                application: applicationId !== null && applicationId !== void 0 ? applicationId : id,
                question: questionId,
                response: response
              }]);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function saveResponse(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var updateCompanyDescription = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee3(description) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return services/* ApiCall.Companies.update */.o.Companies.update(authUser.company.uuid, {
                description: description
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function updateCompanyDescription(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateResponse = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee4(responseId, questionId, response) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return services/* ApiCall.wbso.updateApplicationResponse */.o.wbso.updateApplicationResponse(applicationId !== null && applicationId !== void 0 ? applicationId : id, responseId, {
                application: applicationId !== null && applicationId !== void 0 ? applicationId : id,
                question: questionId,
                response: response
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function updateResponse(_x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();

  var uploadFile = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee5(file) {
      var uploadRes, newData;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return services/* ApiCall.wbso.uploadFile */.o.wbso.uploadFile(applicationId !== null && applicationId !== void 0 ? applicationId : id, file);

            case 2:
              uploadRes = _context5.sent;
              newData = {};
              uploadRes.data.forEach(function (res) {
                var _questions$find;

                var questionKey = (_questions$find = questions.find(function (q) {
                  return q.uuid === res.question;
                })) === null || _questions$find === void 0 ? void 0 : _questions$find.key;

                if (questionKey) {
                  newData[questionKey] = res.response;
                }
              });
              formik.setValues(ApplicationForm_objectSpread(ApplicationForm_objectSpread({}, formik.values), newData));

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function uploadFile(_x8) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleNext = function handleNext() {
    formik.validateForm().then( /*#__PURE__*/function () {
      var _ref6 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee6(errors) {
        var _questionId, _value, _currentValue, _error$response$data$, _error$response$data$2;

        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (errors[currentQuestion.key]) {
                  _context6.next = 54;
                  break;
                }

                if (isAuthenticated) {
                  _context6.next = 4;
                  break;
                }

                setCurrentQuestionIndex(currentQuestionIndex + 1);
                return _context6.abrupt("return");

              case 4:
                _questionId = currentQuestion.uuid;
                _value = formik.values[currentQuestion.key];
                _currentValue = currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.response;

                if (currentQuestion.type === 'Date') {
                  _value = moment_default()(_value).format('DD-MM-YYYY');
                  _currentValue = _currentValue ? moment_default()(_currentValue).format('DD-MM-YYYY') : undefined;
                }

                if (currentQuestion.key === 'phase_description') {
                  _value = JSON.stringify(_value);
                }

                _context6.prev = 9;
                setIsSubmiting(true);

                if (!(_currentValue && _currentValue !== _value)) {
                  _context6.next = 28;
                  break;
                }

                if (!(currentQuestion.key === 'company_description')) {
                  _context6.next = 19;
                  break;
                }

                _context6.next = 15;
                return updateCompanyDescription(_value);

              case 15:
                _context6.next = 17;
                return updateResponse(currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.uuid, _questionId, _value);

              case 17:
                _context6.next = 26;
                break;

              case 19:
                if (!(currentQuestion.question_type === 'FileUpload')) {
                  _context6.next = 24;
                  break;
                }

                _context6.next = 22;
                return uploadFile(_value);

              case 22:
                _context6.next = 26;
                break;

              case 24:
                _context6.next = 26;
                return updateResponse(currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.uuid, _questionId, _value);

              case 26:
                _context6.next = 41;
                break;

              case 28:
                if (!(currentQuestion.key === 'company_description')) {
                  _context6.next = 33;
                  break;
                }

                _context6.next = 31;
                return updateCompanyDescription(_value);

              case 31:
                _context6.next = 41;
                break;

              case 33:
                if (!(currentQuestion.question_type === 'FileUpload')) {
                  _context6.next = 38;
                  break;
                }

                _context6.next = 36;
                return uploadFile(_value);

              case 36:
                _context6.next = 41;
                break;

              case 38:
                if (!(currentQuestionIndex >= 0 && isAuthenticated && !_currentValue)) {
                  _context6.next = 41;
                  break;
                }

                _context6.next = 41;
                return saveResponse(_questionId, _value);

              case 41:
                refetchResponse();
                refetchApplication();

                if (currentQuestionIndex < visibleQuestions.length - 1) {
                  if (currentPage === 'feedback') {
                    setCurrentQuestionIndex(0);
                  } else {
                    setCurrentQuestionIndex(currentQuestionIndex + 1);
                  }
                } else {
                  formik.submitForm();
                }

                _context6.next = 49;
                break;

              case 46:
                _context6.prev = 46;
                _context6.t0 = _context6["catch"](9);
                messageApi.open({
                  type: 'error',
                  content: (_error$response$data$ = (_error$response$data$2 = _context6.t0.response.data[0]) === null || _error$response$data$2 === void 0 || (_error$response$data$2 = _error$response$data$2.response) === null || _error$response$data$2 === void 0 ? void 0 : _error$response$data$2[0]) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : 'Failed to save response'
                });

              case 49:
                _context6.prev = 49;
                setIsSubmiting(false);
                return _context6.finish(49);

              case 52:
                _context6.next = 55;
                break;

              case 54:
                formik.setTouched((0,defineProperty["default"])({}, currentQuestion.key, true));

              case 55:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[9, 46, 49, 52]]);
      }));

      return function (_x9) {
        return _ref6.apply(this, arguments);
      };
    }());
  };

  var handlePrev = function handlePrev() {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  var handleSelectCompany = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee7(company) {
      var _yield$ApiCall$Compan, companyCreated;

      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!isAuthenticated) {
                _context7.next = 22;
                break;
              }

              _context7.prev = 1;
              setIsLoading(true);
              (0,analytics/* trackEvent */.L9)('User selects company', {
                name: company.name,
                kvk: company.kvk_number
              }, authUser === null || authUser === void 0 ? void 0 : authUser.uuid);
              _context7.next = 6;
              return services/* ApiCall.Companies.create */.o.Companies.create({
                name: company.name,
                domain: company.domain,
                website: company.domain,
                kvk_number: company.kvk_number,
                products: ['APPLICATION']
              });

            case 6:
              _yield$ApiCall$Compan = _context7.sent;
              companyCreated = _yield$ApiCall$Compan.data;
              setCompanyData(company);
              setHasCompany(true);
              _context7.next = 12;
              return createApplication(companyCreated.uuid);

            case 12:
              _context7.next = 17;
              break;

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](1);
              console.error('Error selecting company:', _context7.t0);

            case 17:
              _context7.prev = 17;
              setIsLoading(false);
              return _context7.finish(17);

            case 20:
              _context7.next = 25;
              break;

            case 22:
              (0,analytics/* trackEvent */.L9)('User selects company', {
                name: company.name,
                kvk: company.kvk_number
              }, authUser === null || authUser === void 0 ? void 0 : authUser.uuid);
              setCompanyData(company);
              setHasCompany(true);

            case 25:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 14, 17, 20]]);
    }));

    return function handleSelectCompany(_x10) {
      return _ref7.apply(this, arguments);
    };
  }();

  var savePreAuthQuestion = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee8(applicationId, token) {
      var _prompts$slice;

      var values;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              values = prompts === null || prompts === void 0 || (_prompts$slice = prompts.slice(0, LOGIN_REQUIRED_AFTER_QUESTION_INDEX)) === null || _prompts$slice === void 0 ? void 0 : _prompts$slice.map(function (q) {
                return {
                  application: applicationId,
                  question: q.uuid,
                  response: formik.values[q.key]
                };
              });
              _context8.next = 3;
              return services/* ApiCall.wbso.saveApplicationResponse */.o.wbso.saveApplicationResponse(applicationId, values);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function savePreAuthQuestion(_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();

  var createApplication = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee9(companyId) {
      var _result, _appId, _retryResult, _retryAppId;

      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return services/* ApiCall.wbso.createApplication */.o.wbso.createApplication(companyId);

            case 3:
              _result = _context9.sent;
              _appId = _result.data.uuid;
              setApplicationId(_appId);
              return _context9.abrupt("return", _appId);

            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](0);

              if (!(_context9.t0.response && _context9.t0.response.status === 401)) {
                _context9.next = 20;
                break;
              }

              _context9.next = 14;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });

            case 14:
              _context9.next = 16;
              return services/* ApiCall.wbso.createApplication */.o.wbso.createApplication(companyId);

            case 16:
              _retryResult = _context9.sent;
              _retryAppId = _retryResult.data.uuid;
              setApplicationId(_retryAppId);
              return _context9.abrupt("return", _retryAppId);

            case 20:
              throw _context9.t0;

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 9]]);
    }));

    return function createApplication(_x13) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleAuth = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var _token, _user, _user$company, _companyId, _user2$company, _result2, _user2, _appId2;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return signInWithGoogleAccount({
                keepLoggedIn: false
              });

            case 3:
              _token = _context10.sent;
              _context10.next = 6;
              return (0,components/* callMe */.DE)(_token);

            case 6:
              _user = _context10.sent;

              if (!_user) {
                _context10.next = 25;
                break;
              }

              _companyId = _user === null || _user === void 0 || (_user$company = _user.company) === null || _user$company === void 0 ? void 0 : _user$company.uuid;

              if (_companyId) {
                _context10.next = 19;
                break;
              }

              _context10.next = 12;
              return axios_default().post("".concat("https://api.traqqie.com", "/companies/"), {
                name: companyData.name,
                domain: companyData.domain,
                website: companyData.domain,
                kvk_number: companyData.kvk_number,
                products: ['APPLICATION']
              }, {
                headers: {
                  Authorization: "Bearer ".concat(_token)
                }
              });

            case 12:
              _result2 = _context10.sent;
              _context10.next = 15;
              return (0,components/* callMe */.DE)(_token);

            case 15:
              _user2 = _context10.sent;
              _companyId = _user2 === null || _user2 === void 0 || (_user2$company = _user2.company) === null || _user2$company === void 0 ? void 0 : _user2$company.uuid;

              if (_companyId) {
                _context10.next = 19;
                break;
              }

              throw Error('Error signing up user & company');

            case 19:
              if (!_companyId) {
                _context10.next = 25;
                break;
              }

              _context10.next = 22;
              return createApplication(_companyId);

            case 22:
              _appId2 = _context10.sent;
              _context10.next = 25;
              return savePreAuthQuestion(_appId2, _token);

            case 25:
              _context10.next = 30;
              break;

            case 27:
              _context10.prev = 27;
              _context10.t0 = _context10["catch"](0);
              console.log('ERROR', _context10.t0);

            case 30:
              _context10.prev = 30;
              return _context10.finish(30);

            case 32:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 27, 30, 32]]);
    }));

    return function handleAuth() {
      return _ref10.apply(this, arguments);
    };
  }();

  var handleStartApp = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee11() {
      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              if (!(authUser !== null && authUser !== void 0 && authUser.company)) {
                _context11.next = 8;
                break;
              }

              setStartingApp(true);
              _context11.next = 5;
              return createApplication(authUser.company.uuid);

            case 5:
              setHasCompany(true);
              _context11.next = 9;
              break;

            case 8:
              setHasCompany(false);

            case 9:
              setShowIntro(false);
              _context11.next = 15;
              break;

            case 12:
              _context11.prev = 12;
              _context11.t0 = _context11["catch"](0);

              message["default"].error('Failed to starting the application!');

            case 15:
              _context11.prev = 15;
              setStartingApp(false);
              return _context11.finish(15);

            case 18:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 12, 15, 18]]);
    }));

    return function handleStartApp() {
      return _ref11.apply(this, arguments);
    };
  }();

  if (showIntro) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Intro, {
      loading: startingApp,
      onBack: function onBack() {
        return router.push(pages/* PAGE.wbsoApplication */.qX.wbsoApplication);
      },
      onContinue: handleStartApp
    });
  }

  var currentStep = currentQuestionIndex + 1;
  var totalStep = visibleQuestions.length;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col py-8 gap-y-5 font-inter w-full max-w-[1240px] md:gap-y-16 md:py-16 lg:pb-32",
    children: [contextHolder, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col gap-y-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between text-white",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "font-semibold",
          children: ["Step ", hasCompany ? currentStep : 1, ":", ' ', hasCompany ? currentQuestion.title : 'Select Company']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "opacity-60",
          children: [hasCompany ? totalStep - currentStep : totalStep + 1 - currentStep, ' ', "questions remaining"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(progress["default"], {
        showInfo: false,
        className: "h-2",
        percent: currentStep * 100 / totalStep,
        trailColor: "#FFFFFF4D",
        strokeColor: "white"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col-reverse gap-y-4 gap-x-16 xl:flex-row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-full min-h-[425px] flex-col gap-y-4 bg-white rounded-[20px] px-5 py-8 text-g400 xl:max-w-[760px] md:p-10",
        children: [!hasCompany ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col gap-y-3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl mb-4 font-semibold md:text-4xl",
            children: "Select Your Company"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_SearchKVKForm, {
            onHandle: handleSelectCompany
          })]
        }) : currentQuestionIndex >= LOGIN_REQUIRED_AFTER_QUESTION_INDEX && !isAuthenticated ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-max flex flex-col gap-y-2",
          style: {
            maxWidth: '100%',
            overflowWrap: 'break-word'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl font-semibold md:text-4xl",
            children: "You're almost there!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Sign in with Google to continue and discover your potential WBSO value. By signing in, you'll save your progress and gain access to personalized insights about your subsidy opportunity."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-max mt-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleSignInButton/* GoogleSignInButton */.N, {
              handleSignIn: handleAuth,
              text: 'Sign in with Google'
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_QuestionView, {
          formik: formik,
          currentQuestion: currentQuestion
        }), hasCompany && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-wrap gap-x-8 gap-y-4 mt-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "outlined",
            color: "primary",
            className: "w-full flex-1",
            onClick: handlePrev,
            children: "Previous step"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            color: "primary",
            className: "w-full flex-1",
            disabled: isNextDisabled,
            loading: isSubmiting,
            onClick: handleNext,
            children: totalStep - currentStep === 0 ? 'Submit' : 'Next'
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RightItem, {
        feedback: currentFeedback,
        claimValue: claimValue,
        loginNow: loginNow
      })]
    })]
  });
};

var FeedbackCard = function FeedbackCard(_ref12) {
  var feedback = _ref12.feedback,
      onClose = _ref12.onClose;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "jsx-3136609356" + " " + "relative z-[2] max-w-[525px] flex flex-col items-start px-6 pt-5 pb-8 bg-[#F9D549] rounded-3xl font-inter text-g400 lg:w-[525px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-3136609356" + " " + "font-semibold text-2xl",
      children: "Feedback"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.feedback_text
      },
      className: "jsx-3136609356" + " " + "feedback-content mt-2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((styled_jsx_style_default()), {
      id: "3136609356",
      children: [".feedback-content ul{list-style-type:disc !important;padding-left:20px !important;}", ".feedback-content li{margin-bottom:5px !important;}"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "jsx-3136609356" + " " + "flex items-center gap-x-3 mt-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(avatar/* default */.ZP, {
        className: "w-11 h-11"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "jsx-3136609356" + " " + "flex flex-col items-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "jsx-3136609356" + " " + "font-semibold",
          children: "Anna"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "jsx-3136609356",
          children: "Traqqie WBSO Expert"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      width: "42",
      height: "46",
      viewBox: "0 0 42 46",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "jsx-3136609356" + " " + "absolute -right-0.5 -bottom-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M41.6292 45.0117L0 26.7152L35.1717 0L41.6292 45.0117Z",
        fill: "#F9D549",
        className: "jsx-3136609356"
      })
    })]
  });
};

var ClaimCard = function ClaimCard(_ref13) {
  var claimValue = _ref13.claimValue,
      _ref13$loginNow = _ref13.loginNow,
      loginNow = _ref13$loginNow === void 0 ? false : _ref13$loginNow;

  var _useState12 = (0,react.useState)(claimValue ? claimValue : 52300),
      randomValue = _useState12[0],
      setRandomValue = _useState12[1];

  (0,react.useEffect)(function () {
    if (loginNow && !claimValue) {
      var _interval = setInterval(function () {
        var min = 25000; // minimum random value

        var max = 600000; // maximum random value

        var generatedValue = Math.floor(Math.random() * (max - min + 1)) + min;
        setRandomValue(generatedValue);
      }, 2000);

      return function () {
        return clearInterval(_interval);
      }; // Cleanup on unmount
    } else if (claimValue) {
      setRandomValue(claimValue);
    }
  }, [loginNow, claimValue]);
  var textValue = '';
  var description = '';

  if (claimValue) {
    textValue = "\u20AC ".concat((0,numberWithCommas/* numberWithCommas */.x)(claimValue));
    description = 'Your potential WBSO claim';
  } else {
    if (loginNow) {
      textValue = "\u20AC ".concat((0,numberWithCommas/* numberWithCommas */.x)(randomValue));
      description = 'We have enough data! Login to see your claim!';
    } else {
      textValue = "\u20AC ---.---";
      description = 'Answer more to see your claim';
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full max-w-[423px] h-max relative bg-g400 text-white flex flex-col items-start py-4 px-7 rounded-3xl md:px-12 md:py-8",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "/icons/wallet.svg",
      className: "w-24 h-auto absolute left-0 top-0 opacity-50 md:w-44"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "text-[32px] font-semibold z-[2] md:text-6xl md:leading-normal",
      children: textValue
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "font-semibold z-[2]",
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "opacity-70 mt-0.5 z-[2]",
      children: claimValue ? "(based on information you\u2019ve provided)" : ''
    })]
  });
};

var RightItem = function RightItem(_ref14) {
  var feedback = _ref14.feedback,
      claimValue = _ref14.claimValue,
      _ref14$loginNow = _ref14.loginNow,
      loginNow = _ref14$loginNow === void 0 ? false : _ref14$loginNow;

  var _useState13 = (0,react.useState)(true),
      isFeedbackOpen = _useState13[0],
      setIsFeedbackOpen = _useState13[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:hidden",
      children: isFeedbackOpen && feedback ? /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackCard, {
        feedback: feedback,
        onClose: function onClose() {
          return setIsFeedbackOpen(false);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimCard, {
        claimValue: claimValue
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "hidden relative flex-col gap-y-16 pt-4 lg:flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClaimCard, {
        claimValue: claimValue,
        loginNow: loginNow
      }), isFeedbackOpen && feedback && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute right-0 top-[280px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackCard, {
          feedback: feedback,
          onClose: function onClose() {
            return setIsFeedbackOpen(false);
          }
        })
      })]
    })]
  });
};

/* harmony default export */ var components_ApplicationForm = (ApplicationForm);

/***/ }),

/***/ 88264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50888);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "variant", "color", "className", "loading", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      className = _ref.className,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var isDisabled = disabled || loading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('font-sfui text-lg px-3 py-3.5 font-bold rounded-md', 'md:px-12 md:h-[52px]', isDisabled ? 'bg-gray-200 text-black/25 cursor-not-allowed' : variant === 'contained' ? color === 'primary' ? 'bg-g500 text-white' : 'bg-white text-g400' : color === 'primary' ? 'bg-transparent border border-solid border-g400 text-g400' : 'bg-transparent border border-solid border-white text-white', className),
    disabled: disabled
  }, props), {}, {
    children: [loading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: "mr-2"
    }), children]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 33481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ numberWithCommas; }
/* harmony export */ });
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/***/ })

}]);